// Versión de la app nativa que está mostrando esta web.
//
// - iOS (WKWebView): la app añade "NivelaAI-iOS/<versión> (<build>)" al user
//   agent (ver ios/NivelaAI/WebView.swift).
// - Android (TWA): la web corre dentro de Chrome y no se puede tocar el user
//   agent, así que la app abre la web con ?nativeApp=android&appVersion=…&appBuild=…
//   (ver android/…/LauncherActivity.java). captureLaunchParams() los guarda al
//   arrancar y los quita de la URL. Se guardan en sessionStorage y no en
//   localStorage: la TWA comparte almacenamiento con el Chrome del móvil, y
//   abrir luego la web en Chrome no debe parecer la app.
//
// Sirve para esquivar un fallo de una versión antigua o pedir que actualicen
// sin esperar a Apple/Google. Las builds anteriores a esto no envían nada:
// cuentan como build 0 ("antigua").

const KEY = 'nivela_native_app'
const PARAMS = ['nativeApp', 'appVersion', 'appBuild']
const UA_RE = /NivelaAI-(iOS|Android)\/([\w.]+) \((\d+)\)/

export function captureLaunchParams() {
  try {
    const url = new URL(window.location.href)
    const platform = url.searchParams.get('nativeApp')
    if (!platform) return
    const info = {
      platform: platform.toLowerCase(),
      version: url.searchParams.get('appVersion') || null,
      build: Number(url.searchParams.get('appBuild') || 0),
    }
    try { sessionStorage.setItem(KEY, JSON.stringify(info)) } catch { /* sin almacenamiento */ }
    PARAMS.forEach(p => url.searchParams.delete(p))
    const qs = url.searchParams.toString()
    window.history.replaceState(window.history.state, '', url.pathname + (qs ? `?${qs}` : '') + url.hash)
  } catch { /* URL rara: no bloquear el arranque */ }
}

// { platform: 'ios' | 'android', version, build } en la app nativa; null en el navegador
export function nativeAppInfo() {
  const m = UA_RE.exec(navigator.userAgent || '')
  if (m) return { platform: m[1].toLowerCase(), version: m[2], build: Number(m[3]) }
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null')
    if (saved && saved.platform) return saved
  } catch { /* sin almacenamiento */ }
  if (window.webkit?.messageHandlers?.nativeCamera) return { platform: 'ios', version: null, build: 0 }
  return null
}

// true si es la app nativa con build >= minBuild (false en el navegador)
export function nativeBuildAtLeast(minBuild, platform = null) {
  const info = nativeAppInfo()
  return !!info && (!platform || info.platform === platform) && info.build >= minBuild
}

// Etiqueta corta para Sentry/registros: "web", "ios 1.1 (5)", "android 1.0.0 (1)"
export function nativeAppLabel() {
  const info = nativeAppInfo()
  if (!info) return 'web'
  return info.version ? `${info.platform} ${info.version} (${info.build})` : `${info.platform} antigua`
}
